import React, { Component, Dispatch } from 'react';
import ProcessingActivity from '../activity-proccessing/processing-activity';
import { ISignleActivityCard } from '../../../../models/components/single-activity-card';
import Translator from '../../../../core/i18n';
import { Common } from '../../../../core/common';
import Moment from 'moment';
import { IAppState, IAction } from '../../../../models/action/core';
import { connect } from 'react-redux';
import * as Actions from '../../../../store/actions/virtualClass';
import { enrollmentStatus } from '../../../../models/enums/enrollmentStatus';
import ProgressCircle from '../../../progress-circle/progress-circle';
import { SecurityContextType, SecurityPermissionType } from '../../../../core/SecurityContext';
import { Log } from 'ng2-logger';
import { UserType } from '../../../../models/enums/userType';
import { getCourseContentsWeekActivitiesAction, SetUpdateInput } from '../../../../store/actions/coursePage';
import EdiText from 'react-editext';
import Countdown from 'react-countdown';
import { CoursePageService } from '../../../../api/course-page-service';
import { Notification } from '../../../notification/main';
import ReactGA from 'react-ga4';
import ProgressCircleStudent from '../../../progress-circle/progress-circle-student';
import { ActivityCompletionType } from '../../../../models/enums/activityCompletionType';
import * as EnrollmentActions from '../../../../store/actions/enrollment';
import { VirtualClassType } from '../../../../models/enums/VirtualClassType';
import moment from 'moment';
import Tooltip from '../../../tooltip/main';

const _logger = Log.create('virtualClass_activityCard');
const maxEditTextLength = 65;
let _common: Common;
const T = Translator.create();
const coursePageService = new CoursePageService();
let nowDate = new Date();

const virtualclassbg = `${process.env.PUBLIC_URL}/images/virtualClassCard/virtualclass.png`;

interface IObj {
    hours: any;
    minutes: any;
    seconds: any;
    completed: any;
    days: any;
}

export class CVirtualClass extends Component<ISignleActivityCard> {
    state = {
        nowDate: Moment(this.props.activityCard!.serverDate).format('yyyy-MM-DDTHH:mm:ss'),
        editTextValue:
            this.props.activityCard!.name!.toString().length > maxEditTextLength
                ? this.props.activityCard!.name!.slice(0, maxEditTextLength).toString() + '...'
                : this.props.activityCard!.name!.toString(),
        editTextHandleValue: this.props.activityCard!.name!.toString(),
        virtualClassLiveProgress: 0,
        virtualClassReplayProgress: 0,
        activityId: "",
        totalSeconds: 0,
        replaySeconds: 0
    };

    constructor(props: any) {
        super(props);
        _common = new Common();
        Moment.locale(T.i18next.language);
        this.onClickJoin = this.onClickJoin.bind(this);
        this.afterSave = this.afterSave.bind(this);
    }

    public onClickJoin = () => {
        if (this.props.activityCard!.virtualClassRemoteId) {
            ReactGA.event({
                category: window.location.host,
                action: 'G_VIRTUAL_CLASS_REPLAY_CLICKED',
                label: 'G_VIRTUAL_CLASS_REPLAY_CLICKED',
                nonInteraction: true,
            });
            this.props.dispatch(Actions.joinVirtualClassGetAction(this.props.activityCard!.activityId!, this.props.activityCard!.virtualClassRemoteId, 'CourseMain', 'get', this.callback));

        }
    };

    public onClickRecalculate = () => {
        this.props.dispatch(Actions.reCalculateVirtualClass(this.props.activityCard!.activityId!, 'RecalculateMain', 'get', this.callbackRecalculate));
    };

    callbackRecalculate = (value: any) => {
        const { activityCard } = this.props

        if (value) {

            this.setState({ activityId: value.activityId, virtualClassLiveProgress: value.virtualClassLiveProgress, virtualClassReplayProgress: value.virtualClassReplayProgress, totalSeconds: value.totalSeconds, replaySeconds: value.replaySeconds ?? activityCard?.enrollmentReplaySecond });
            Notification.setNotification('success', T.t('r_virtualclass_progress_updated'), 'topRight');

        }
        else {
            Notification.setNotification('error', T.t('r_virtual_class_replay_link_error_message'), 'topRight');
        }
    }

    callback = (value: any) => {
        if (value) {
            window.open(value, '_blank');

        }
        else {
            Notification.setNotification('error', T.t('r_virtual_class_replay_link_error_message'), 'topRight');
        }
    }

    afterSave() {
        this.props.dispatch(getCourseContentsWeekActivitiesAction(
            this.props.coursePageClassId ? this.props.coursePageClassId : '0',
            this.props.coursePageActivityId ? this.props.coursePageActivityId : '0',
            this.props.weekOrUnitId !== '0',
            0,
            1000,
            this.props.weekOrUnitId === '0' ? '-1' : this.props.weekOrUnitId!,
            false,
            false,
            null,
            'contentWeekActivities',
            'get', undefined,this.props.sortKey ?? "-"));
    }

    public handleSave = (name: any) => {
        if (this.props.activityCard?.activityId && this.props.activityCard?.name !== name) {
            this.props.dispatch(
                SetUpdateInput(this.props.activityCard.activityId, name, 'api/activity/updateActivityName', 'POST', this.props.classId!, this.afterSave)
            );
            this.setState({
                editTextValue: name.length > maxEditTextLength
                    ? name.slice(0, maxEditTextLength).toString() + '...'
                    : name.toString(), editTextHandleValue: name
            });
        }
    };

    public handleClick(value: string) {
        this.setState({ editTextValue: value });
    };

    public renderer = (params: IObj) => {
        return (
            <div className="d-flex" style={{ alignItems: 'center', justifyContent: 'center' }}>
                <div className="">
                    <div className="countdown-timer" style={{ color: '#fff' }}>
                        {params.days <= 9 ? '0' + params.days : params.days} <span className='time-sign'>{T.t('r_time_day')}</span>
                    </div>
                </div>
                <div className="">
                    <div className="countdown-timer" style={{ color: '#fff', marginLeft: '15px' }}>
                        {params.hours <= 9 ? '0' + params.hours : params.hours} <span className='time-sign'>{T.t('r_time')}</span>
                    </div>
                </div>
                <div className="">
                    <div className="countdown-timer" style={{ color: '#fff', marginLeft: '20px' }}>
                        {params.minutes < 9 ? '0' + params.minutes : params.minutes}
                        <span className='time-sign'>{T.t('r_time_minute')}</span>
                    </div>
                </div>
            </div>
        );
    };
    public countdownIsComplete = () => {
        this.setState({ nowDate: Moment(this.props.activityCard!.serverDate).add(5, 'second').format('yyyy-MM-DDTHH:mm:ss') });
    };
    public calculateDistance = () => {
        // mili to min => mili*1.67*(10^-5) ==  mili*167/10000000
        let distanceMinutes = ((((Moment(this.props.activityCard!.actualStartTime).toDate().getTime()) - (Moment(this.props.activityCard!.serverTime).toDate().getTime())) * 167) / 10000000);
        return distanceMinutes;

    };

    onClickRefresh = (enrollStatus: enrollmentStatus) => {
        ReactGA.event({
            category: window.location.host,
            action: 'G_REFRESH_ACTIVITY_CLICKED',
            label: 'G_REFRESH_ACTIVITY_CLICKED',
            nonInteraction: true,
        });
        if (enrollStatus !== enrollmentStatus.Completed) {
            coursePageService.RequestClearCourseCacheData({ ClassId: this.props.coursePageClassId ? this.props.coursePageClassId : '0', CourseId: this.props.coursePageActivityId ? this.props.coursePageActivityId : '0' });
            this.props.dispatch(EnrollmentActions.enrollmentGetAction(this.props.coursePageClassId ? this.props.coursePageClassId : '0', this.props.activityCard!.activityId ?? '0'));
        }
    };

    renderCardHeader = () => {
        let enrollmentData = this.props.enrollmentData!.filter(enr => enr.activityId === this.props.activityCard!.activityId);
        let enrollmentDataStatus = enrollmentData.length > 0 ? enrollmentData[0].status : enrollmentStatus.NotStarted
        let activityEnrollmentStatus = this.props.activityCard!.enrollmentStatus ? this.props.activityCard!.enrollmentStatus
            : enrollmentDataStatus;

        let activityDeadline = this.props.activityCard!.taskDeadLine ? this.props.activityCard!.taskDeadLine : null;

        return (
            <div className="card-header">
                <div className={"activity-title "+ (!_common.isArabic(this.state.editTextValue, document.body.getAttribute('dir')) ? 'arabic-text-card' : '')}>
                    <img
                        src={_common.GetActivityTypeIcons('virtualclass')}
                        alt="Virtual Class Activity Icon"
                    />
                    {
                        Common.HasPermission(SecurityContextType.Class, SecurityPermissionType.Activity_Add, this.props.classId!) ? (
                            <div title={this.props.activityCard!.name} className="visible">
                                <EdiText
                                    type="text"
                                    onSave={this.handleSave}
                                    onCancel={event => this.handleClick(this.state.editTextValue.length > maxEditTextLength
                                        ? this.state.editTextValue.slice(0, maxEditTextLength).toString() + '...'
                                        : this.state.editTextValue.toString())}
                                    onEditingStart={event => this.handleClick(this.state.editTextHandleValue)}
                                    value={this.state.editTextValue}
                                    showButtonsOnHover={true}
                                    saveButtonClassName="hideEditextSaveButton"
                                    cancelButtonClassName="hideEditextCancelButton"
                                    validationMessage={T.t('r_forum_tree_character')}
                                    // tslint:disable-next-line:jsx-no-lambda
                                    validation={val => val.trim().length >= 3}
                                    editOnViewClick={true}
                                    submitOnEnter={true}
                                    cancelOnEscape={true}
                                    className={'font-weight-bold mobile-activity-title web-activity-title'+ (!_common.isArabic(this.state.editTextValue, document.body.getAttribute('dir')) ? ' arabic-text-direction' : '')}
                                    tabIndex={0}
                                />
                            </div>
                        ) : <div title={this.props.activityCard!.name} className={"visible mobile-activity-title web-activity-title" + (!_common.isArabic(this.state.editTextValue, document.body.getAttribute('dir')) ? ' arabic-text-direction' : '')} style={{ cursor: 'pointer', lineHeight: 1.3, whiteSpace: 'pre-line', textOverflow: 'ellipsis' }} tabIndex={0}>{this.props.activityCard!.name}</div>
                    }

                    <ProcessingActivity
                        externalCssClassName="ml-auto show_on_mobile"
                        activityId={this.props.activityCard!.activityId}
                        activityType={this.props.activityCard!.activityType}
                    />

                </div>
                <div className="activity-status">
                    {this.props.activityCard?.alwaysOnTop ? <span className="pinned"></span> : ''}
                    {this.props.activityCard!.virtualClassType == VirtualClassType.Zoom
                        ?
                        <span className="badges badges-virtual-class-zoom activity-type">Zoom</span>
                        :
                        <span className="badges badges-virtual-class-perculus activity-type">Perculus</span>
                    }
                    <span className="badges badges-virtual-class activity-type">{T.t('r_activity_type_VirtualClass')}</span>

                    {/* <h6 style={{ margin: 'auto' }}>{this.props.activityCard?.alwaysOnTop ? '📍' : ''}</h6> */}
                    {this.props.activityCard!.taskDeadLine ? <div className="last-date" style={{ paddingRight: '20px' }} data-toggle="tooltip" data-placement="top" title={T.t('r_activity_deadline')}>

                        <Tooltip data={T.t('r_activity_deadline') + ': ' + Moment(this.props.activityCard!.taskDeadLine).format(
                            _common.GetDateFormatFromPrefrences(this.props.userPreferences!, 3)
                        )} position='top' > <span><i className="material-icons mr-1 text-warning">calendar_today</i></span>
                        </Tooltip>
                    </div> : ''}
                    {this.props.userType === UserType.Student ? (
                        <>
                            <button className='alms-btn btn-default btn-icon' onClick={() => this.onClickRefresh(activityEnrollmentStatus)} style={{ minWidth: 'auto' }}>
                                <Tooltip data={T.t('r_activity_update_enrollment')} position='top'>
                                    <img style={{ cursor: 'pointer' }} src={_common.GetDefaultIcons('refresh')} alt="refresh" />
                                </Tooltip>
                            </button>
                            <ProgressCircleStudent enrollmentStatus={activityEnrollmentStatus ?? enrollmentStatus.NotStarted} deadline={activityDeadline} isTheCompletionCriterionOver={this.checkIsCopletionCriteriaNotCompleted()} activityCard={this.props.activityCard} />
                        </>
                    ) : (
                        <ProgressCircle activityCard={this.props.activityCard} percent={this.props.activityCard!.completedUser === 0 ? 0 : ((this.props.activityCard!.completedUser! * 100) / this.props.activityCard!.totalEnrollUser!)} />
                    )}
                    &nbsp;
                    <ProcessingActivity
                        externalCssClassName="hide_on_mobile"
                        activityId={this.props.activityCard!.activityId}
                        activityType={this.props.activityCard!.activityType}
                    />
                </div>
            </div>
        )
    }

    checkPrerequisite = () => {
        let isPrerequisiteCompleted = false
        if (this.props.activityCard!.prerequisiteActivityId && this.props.userType === UserType.Student) {
            if (this.props.enrollmentData) {
                let prerequisiteActivities = this.props.enrollmentData.filter(f => f.activityId === this.props.activityCard!.prerequisiteActivityId)
                if (prerequisiteActivities.length > 0) {
                    if (prerequisiteActivities[0].status === enrollmentStatus.Completed && this.props.userType === UserType.Student) {
                        isPrerequisiteCompleted = true;

                    }
                }

            }
        }
        return isPrerequisiteCompleted;
    }

    activityHasNoCriteria = () => {
        let isActvityStarted = this.state.nowDate >= (this.props.activityCard!.actualStartTime ? this.props.activityCard!.actualStartTime : '')
        let virtualClassPassed = this.state.nowDate > this.props.activityCard!.actualEndTime!.toString()

        let isCompleted = !this.props.activityCard?.enrollmentVirtualClassLiveProgress && isActvityStarted && virtualClassPassed;
        if (this.props.activityCard?.completionType === ActivityCompletionType.ProgressLiveOrArchive) {
            isCompleted = !this.props.activityCard.enrollmentVirtualClassLiveProgress && !this.props.activityCard.enrollmentVirtualClassReplayProgress
        }

        return isCompleted
    }

    activtyHasCriteria = (isCompleted: boolean) => {
        let _isCompleted = isCompleted;
        let virtualClassPassed = this.state.nowDate > this.props.activityCard!.actualEndTime!.toString()

        if (!virtualClassPassed) {
            _isCompleted = false;
        }
        else {
            if (this.props.activityCard?.enrollmentVirtualClassLiveProgress && this.props.activityCard?.enrollmentVirtualClassLiveProgress >= this.props.activityCard?.completionCriteria!) {
                _isCompleted = false;
            }
            if (this.props.activityCard?.completionType === ActivityCompletionType.ProgressLiveOrArchive && (this.props.activityCard.enrollmentVirtualClassReplayProgress && this.props.activityCard.enrollmentVirtualClassReplayProgress >= this.props.activityCard?.completionCriteria!) || !this.props.activityCard?.enrollmentVirtualClassReplayProgress) {
                _isCompleted = false;
            }
        }

        return _isCompleted
    }

    checkIsCopletionCriteriaNotCompleted = () => {
        let isActvityStarted = this.state.nowDate >= (this.props.activityCard!.actualStartTime ? this.props.activityCard!.actualStartTime : '')
        let virtualClassPassed = this.state.nowDate > this.props.activityCard!.actualEndTime!.toString()
        let isCompleted;

        if (this.props.activityCard?.completionType === ActivityCompletionType.ProgressLive || this.props.activityCard?.completionType === ActivityCompletionType.AttendLiveSession || this.props.activityCard?.completionType === ActivityCompletionType.ProgressLiveOrArchive) {
            isCompleted = true;

            if (isActvityStarted && this.props.activityCard?.completionCriteria && this.props.activityCard?.completionCriteria > 0) {
                isCompleted = this.activtyHasCriteria(isCompleted)
            }
            else {

                isCompleted = this.activityHasNoCriteria()
            }

        }
        return isCompleted;
    }

    checkVirtualClassCompleted = () => {
        let virtualClassPassed = this.props.activityCard && this.state.nowDate > this.props.activityCard.actualEndTime!.toString()
        let isActvityStarted = this.state.nowDate >= (this.props.activityCard!.actualStartTime ? this.props.activityCard!.actualStartTime : '')
        if (this.props.activityCard!.virtualClassIsPacked || (virtualClassPassed)) {

            return true;
        }
        return false;
    }

    humanizeSecond = (time: number) =>
    {
        let duration = moment.duration(time, 'seconds');

        let formattedTime = '';
        if (duration.hours() > 0) {
          formattedTime += duration.hours() +  ' ' + T.t('r_time')+ ' '; 
        }
        if (duration.minutes() > 0 || duration.hours() > 0) {
          formattedTime += String(duration.minutes()).padStart(2, '0') +  ' ' + T.t('r_time_minute') + ' ';
        }
        formattedTime += String(duration.seconds()).padStart(2, '0')+  ' '+ T.t('r_time_second');
        
        return formattedTime;
    }


    renderNotStartedActivityContent = () => {
        const { nowDate } = this.state;
        const { activityCard } = this.props;
        const { actualStartTime, actualEndTime, virtualClassIsPacked, totalVirtualClassDuration, name } = activityCard || {};

        const isActivityStarted = nowDate >= (actualStartTime ?? '');
        const virtualClassPassed = activityCard && nowDate > (actualEndTime ? actualEndTime.toString() : '');
        const formattedStartDate = Moment(actualStartTime).format('DD MMMM');
        const formattedStartTime = Moment(actualStartTime).format('HH:mm');
        const formattedDuration = (totalVirtualClassDuration ?? 0).toFixed(0);
        let enrollmentData = this.props.enrollmentData!.filter(enr => enr.activityId === this.props.activityCard!.activityId);
        const renderClassTime = (
            <div className="d-flex justify-content-between">
                <div className="virtual-class-time mx-2">
                    <span><img src={_common.GetDefaultIcons('datestart')} alt="" />{formattedStartDate}</span>
                </div>
                <div className="virtual-class-time mx-2">
                    <span><img src={_common.GetDefaultIcons('timeclock')} alt="" />{formattedStartTime}</span>
                </div>
                <div className="virtual-class-time mx-2">
                    <span><img src={_common.GetDefaultIcons('hourglass')} alt="" />{formattedDuration} {T.t('r_short_min')}</span>
                </div>
            </div>
        );

        const renderClassBackground = (title: string, buttonText: string, time: number) => (
            <div className="virtual-class-bg" style={{ backgroundImage: `url(${virtualclassbg})` }}>
                {renderClassTime}
                <div className="virtual-class-title">
                  {time> 0 && <span className="vc-middle-title mobile-not-show text-center">{title} : {this.humanizeSecond(time)}</span>}  
                    <span className="vc-timer">{T.t('r_virtual_done')}</span>
                </div>
                <div className="virtual-class-button">
                    <button onClick={this.onClickJoin} className="success-btn ">{buttonText}</button>
                </div>
            </div>
        );

        if (isActivityStarted) {
            if (virtualClassIsPacked || virtualClassPassed) {
                return (
                    <div className="row mx-0">
                     { renderClassBackground(T.t('r_virtual_duration'), T.t('r_virtual_class_watchagain'), enrollmentData.length > 0 && enrollmentData[0].virtualClassTotalSeconds ? enrollmentData[0].virtualClassTotalSeconds: 0)}
                    </div>
                );
            } else {
                return (
                    <div className="row mx-0">
                        <div className="virtual-class-bg" style={{ backgroundImage: `url(${virtualclassbg})` }}>
                            {renderClassTime}
                            <div className="virtual-class-title">
                                <span className="vc-title">{name}</span>
                                <span className="vc-status">{T.t('r_activity_virtualClass_is_begin')}</span>
                            </div>
                            <div className="virtual-class-button">
                                <button onClick={this.onClickJoin} className="success-btn ">{T.t('r_virtual_class_join')}</button>
                            </div>
                        </div>
                    </div>
                );
            }
        }

        return '';
    }


    renderStartedActivityContent = () => {

        const { actualStartTime, preparationTime } = this.props.activityCard || {}
        const actualStartMoment = moment(actualStartTime);
        const nowDateMoment = moment(nowDate);
        const adjustedStartMoment = actualStartMoment.subtract(preparationTime, 'minutes');

        return (
            (this.state.nowDate <= (this.props.activityCard!.actualStartTime ?? '')) ?
                <div className="row mx-0 ">
                    <div className="virtual-class-bg" style={{ backgroundImage: `url(${virtualclassbg})` }}>
                        <div className="d-flex justify-content-between">
                            <div className="virtual-class-time mx-2">
                                <span><img src={_common.GetDefaultIcons('datestart')} alt="" />{(Moment(this.props.activityCard!.actualStartTime)).format('DD MMMM')}</span>
                            </div>
                            <div className="virtual-class-time mx-2">
                                <span><img src={_common.GetDefaultIcons('timeclock')} alt="" />{(Moment(this.props.activityCard!.actualStartTime)).format('HH:mm')}</span>
                            </div>
                            <div className="virtual-class-time mx-2">
                                <span><img src={_common.GetDefaultIcons('hourglass')} alt="" />{(this.props.activityCard!.totalVirtualClassDuration!).toFixed(0)}  {T.t('r_short_min')}</span>
                            </div>
                        </div>
                        <div className="virtual-class-title">
                            <span className="vc-middle-title text-center">{T.t('r_activity_virtualClass_start_time')}</span>
                            <Countdown onComplete={this.countdownIsComplete}
                                // tslint:disable-next-line:jsx-no-lambda
                                now={() => nowDate.getTime()}
                                date={new Date(this.props.activityCard!.actualStartTime!).getTime()} renderer={this.renderer} />
                            <span className="vc-middle-title text-center">{this.props.activityCard!.name}</span>
                        </div>
                        {(this.props.userType !== UserType.Student && nowDateMoment.isSameOrAfter(adjustedStartMoment) && ((this.props.activityCard!.customProperty3) >= this.calculateDistance())) ?
                            <div className="virtual-class-button">
                                <button onClick={this.onClickJoin} className="success-btn ">{T.t('r_virtual_class_join')}</button>
                            </div>
                            : ''}
                    </div>
                </div>
                : ''
        )
    }

    renderDescription = () => {
        return (
            (this.props.activityCard!.description && _common.removeHtmlTags(this.props.activityCard!.description).length > 0 )  ? <><hr className="bottom-border-2 mobile-not-show mx-0" />
                <div className="mobile-not-show row new-activity-padding">
                    <div className="col d-flex justify-content-start align-items-baseline new-activity-block" >
                        <img src={_common.GetDefaultIcons('infoicon')} className="mr-2" alt="" />
                        <p className="card-info-text card-info-text-width mobile-activity-description">
                            <b>{T.t('r_add_exam_teacher_note')}</b><br /><span id='instructor_note' className={(!_common.isArabic(this.props.activityCard!.description, document.body.getAttribute('dir')) ? 'arabic-text-direction' : '')} dangerouslySetInnerHTML={{ __html: this.props.activityCard!.description }} />
                        </p>
                    </div>
                </div></> : ''
        )
    }

    viewCalculating = (endTime: any) => {
        if (Moment(endTime).add(2, "days").isAfter()) {
            return T.t('r_calculating');
        }
        else {
            return '';
        }
    }

    renderLiveProgress = () => {
        const { activityCard } = this.props;
        const { activityId, virtualClassLiveProgress, totalSeconds } = this.state;

        if (!activityCard) {
            return null;
        }

        let progressPercent = Math.min(activityCard.enrollmentVirtualClassLiveProgress ?? 0, 100);

        let progressTime;

        if (activityCard.enrollmentVirtualClassLiveProgress) {
            const totalSeconds = activityCard.enrollmentTotalSecond ?? 0;
            progressTime = `${totalSeconds} ${T.t('r_time_second')}`;
        } else {
            progressTime = this.viewCalculating(activityCard.actualEndTime);
        }

        if (activityId && activityId === activityCard.activityId && totalSeconds > 0) {
            progressPercent = virtualClassLiveProgress || 0;
            progressTime = `${totalSeconds || 0} ${T.t('r_time_second')}`;
        }

        return (
            <div className="row d-flex align-items-center pb-2 pt-2 mobile-not-show">
                <div className="col-3">
                    <span className="progress-bar-text">{T.t('r_sync_virtual_class_viewers')}</span>
                </div>
                <div className="col-7">
                    <div className="e-lesson-progress">
                        <div className="progress">
                            <div
                                className="progress-bar"
                                style={{ width: `${progressPercent}%` }}
                                aria-valuenow={progressPercent}
                                aria-valuemin={0}
                                aria-valuemax={activityCard.totalVirtualClassDuration ?? 100}
                            />
                        </div>
                    </div>
                </div>
                <div className="cw-10 d-flex flex-column">
                    <span className="progress-percent">{progressPercent}%</span>
                    <span className="progress-time"><b>{progressTime}</b></span>
                </div>
            </div>
        );
    };


    renderReplayProgress = () => {
        const { activityCard } = this.props;
        const { activityId, virtualClassReplayProgress, replaySeconds } = this.state;

        if (!activityCard) {
            return null;
        }

        if (activityCard.virtualClassType === VirtualClassType.Zoom) {
            return null;
        }

        let progressPercent = activityCard.enrollmentVirtualClassReplayProgress ?? 0;
        let progressTime = activityCard.enrollmentReplaySecond ?? 0;

        if (progressPercent > 100) {
            progressPercent = 100;
        }

        if (activityId && activityId === activityCard.activityId) {
            progressPercent = virtualClassReplayProgress || 0;
            progressTime = replaySeconds || 0;
        }

        return (
            <div className="row d-flex align-items-center pb-2 pt-2 mobile-not-show">
                <div className="col-3">
                    <span className="progress-bar-text">{T.t('r_async_virtual_class_viewers')}</span>
                </div>
                <div className="col-7">
                    <div className="e-lesson-progress">
                        <div className="progress">
                            <div
                                className="progress-bar"
                                style={{ width: `${progressPercent}%` }}
                                aria-valuenow={progressPercent}
                                aria-valuemin={0}
                                aria-valuemax={activityCard.totalVirtualClassDuration ?? 100}
                            />
                        </div>
                    </div>
                </div>
                <div className="cw-10 d-flex flex-column">
                    <span className="progress-percent">{progressPercent}%</span>
                    <span className="progress-time">
                        <b>
                            {activityCard.enrollmentVirtualClassReplayProgress
                                ? `${progressTime} ${T.t('r_time_second')}`
                                : this.viewCalculating(activityCard.actualEndTime)}
                        </b>
                    </span>
                </div>
            </div>
        );
    };


    renderPassedActivityContent = () => {

        let enrollmentData = this.props.enrollmentData!.filter(enr => enr.activityId === this.props.activityCard!.activityId);
        let enrollmentDataStatus = enrollmentData.length > 0 ? enrollmentData[0].status : enrollmentStatus.NotStarted
        let activityEnrollmentStatus = this.props.activityCard!.enrollmentStatus ? this.props.activityCard!.enrollmentStatus
            : enrollmentDataStatus;

        let doesActivityPassed = this.state.nowDate >= (this.props.activityCard!.actualEndTime ?? '');
        let isActvityStarted = this.state.nowDate >= (this.props.activityCard!.actualStartTime ? this.props.activityCard!.actualStartTime : '')

        return (
            (this.props.userType === UserType.Student && (doesActivityPassed || activityEnrollmentStatus)) ?
                <div className='col-12 d-flex justify-content-center align-items-center p-0'>
                    <div className='col-md-9 mobile-not-show'>
                        {this.renderLiveProgress()}
                        {this.renderReplayProgress()}
                    </div>
                    <div className='col-3 align-middle progress-mobile-btn'>

                        <button className='alms-btn btn-default btn-icon' onClick={this.onClickRecalculate}>
                            <img style={{ cursor: 'pointer', marginRight: "5px" }} src={_common.GetDefaultIcons('refresh')} alt="refresh" />
                            {T.t('r_recalculate')}
                        </button>
                    </div>
                </div>

                : ''
        )
    }

    public render() {
        let isCompletedPrerequisiteActivity: boolean = this.checkPrerequisite();

        return (
            <div className="col-12 mobile-padding card-width">
                <div className={this.props.activityCard!.activeStatus === 0 ? 'card new-activity border-pasif' : 'card new-activity'}>
                    {this.renderCardHeader()}
                    <hr className="bottom-border-2 mobile-not-show" />
                    {!isCompletedPrerequisiteActivity && this.props.activityCard!.prerequisiteActivityId && this.props.userType === UserType.Student ?
                        <div className='row' style={{
                            opacity: 0.5, flexDirection: 'column',
                            fontSize: '1em !important',

                            alignItems: 'center',
                            justifyContent: 'center',
                            textAlign: 'center',
                        }}>
                            <i className="material-icons" style={{ fontSize: '96px', marginTop: '10px' }}>lock</i>
                            <h5 className="font-medium">
                                {T.t('r_activity_restriction_by_another_message').replace('{0}', this.props.activityCard!.name).replace('{1}', this.props.activityCard!.prerequisiteActivityName)}
                            </h5>
                        </div> :
                        <div className="card-body" style={{ padding: '0px 23px 0px 23px' }}>

                            {this.renderNotStartedActivityContent()}
                            {this.renderStartedActivityContent()}
                            {this.renderPassedActivityContent()}
                            {this.renderDescription()}
                        </div>
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: ISignleActivityCard): ISignleActivityCard => {
    if (!state) {
        return ownProps;
    }

    const newProps: ISignleActivityCard = Object.assign({}, ownProps, {
        virtualClassPerculusUrl: state.virtualClass.virtualClassPerculusUrl,
        userPreferences: state.profile.userPreferences.preferences,
        userType: state.login.identitiy.userType,
        coursePageClassId: state.coursePage.coursePageClassId,
        enrollmentData: state.enrollment.enrollmentData,
        coursePageActivityId: state.coursePage.coursePageActivityId,
        weekOrUnitId: state.coursePage.weekOrUnitId,
        courseContentWeeksActivities: state.coursePage.courseContentWeekActivities,
        sortKey: state.coursePage.courseSortingKey
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = (
        next.coursePage.coursePageActivityId === prev.coursePage.coursePageActivityId &&
        next.coursePage.coursePageClassId === prev.coursePage.coursePageClassId &&
        next.coursePage.courseSortingKey === prev.coursePage.courseSortingKey &&
        next.login.identitiy.userType === prev.login.identitiy.userType &&
        next.coursePage.weekOrUnitId === prev.coursePage.weekOrUnitId &&
        next.profile.userPreferences.preferences === prev.profile.userPreferences.preferences &&
        next.coursePage.courseContentWeekActivities === prev.coursePage.courseContentWeekActivities &&
        next.coursePage.activityCard === prev.coursePage.activityCard &&
        next.enrollment.enrollmentData === prev.enrollment.enrollmentData &&
        next.virtualClass.virtualClassPerculusUrl === prev.virtualClass.virtualClassPerculusUrl

    );
    return ret;
};

const VirtualClass = connect(
    mapStateToProps,
    dispatchProps
)(CVirtualClass);

export default VirtualClass;
